<template>
  <div class="cardCustom">
    <div class="card cardCustom__side">
      <div class="cardCustom__header">
        <div class="cardCustom__header-text"></div>
        <div class="cardCustom__header-info__item">
          <button
            v-if="infoText"
            v-tooltip="{
              content: infoText,
              placement: 'bottom-center',
              classes: ['info'],
            }"
          >
            <i class="fas fa-info-circle" />
          </button>
        </div>
      </div>

      <div class="cardContent">
        <bubble-chart class="mt-3 ml-3" :chartData="chartData" :options="options" :style="myStyles"></bubble-chart>
        <div v-if="loading" class="loadingSection lds-dual-ring"></div>
        <div v-else class="trees-title">
          <div v-if="number_of_trees > 0">
            <span class="number_of_trees">{{ number_of_trees }} trees</span>
            <br />
            <span class="trees-text">are required to offset your annual CO2 footprint.</span>
            <br />
            <span>Each point represents 10 trees, that are required to offset your club's CO2 footprint.</span>
            <br />
            <span>
              Your annual carbon footprint of
              <span class="bold-font"> {{ Math.round(footprintInfo.co2_footprint_minus_co2_sequestration) }} lbs</span>
              can be sequestered by <span class="bold-font">{{ number_of_trees }} trees</span>
            </span>
          </div>
          <!--          <div v-else>-->
          <!--            <span class="number_of_trees">Not enough data.</span>-->
          <!--            <br>-->
          <!--            <span class="trees-text">Seems like your CO2 Footprint is already offset by your sequestration level.</span>-->
          <!--            <br>-->
          <!--            <span>Try to <span class="bold-font">add more data</span> to see your actual CO2 emission.</span>-->
          <!--          </div>-->
          <div v-else>
            <span class="number_of_trees">{{ Math.abs(number_of_trees) }} trees</span>
            <br />
            <span class="trees-text">are equivalent to your club’s CO2 sequestration</span>
            <br />
            <span>This means that you are sequestering more CO2 than you generate through your operation.</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Card from './Card.vue';
import CardWithSides from '@/components/Cards/CardWithSides';
import BubbleChart from '@/controllers/Charts/BubbleChart';

export default {
  name: 'BubbleChartCard',
  components: {
    BubbleChart,
    CardWithSides,
    Card,
  },
  props: {
    infoText: String,
    title: String,
    subTitle: String,
    loading: Boolean,
    chartHeight: Number,
    chartData: {
      type: Object,
      default: null,
    },
    options: {
      type: Object,
      default: null,
    },
    footprintInfo: {
      type: Object,
      default: null,
    },
  },
  computed: {
    number_of_trees() {
      return Math.round(this.footprintInfo.co2_footprint_minus_co2_sequestration / this.footprintInfo.each_tree_costs);
    },
    blurStyles() {
      return {
        height: `${this.chartHeight}px`,
      };
    },
    myStyles() {
      return {
        height: '100%',
        position: 'relative',
      };
    },
  },
};
</script>
<style>
.cardContent {
  width: 100%;
  height: 100%;
}

.small {
  margin-top: 3rem;
}
</style>
